import { defineStore } from 'pinia';
import { editGoodsSn, editGoodsSnShuixibiao, getSnList, updateSNIsOnSale } from '@/api/seller/sn';

interface SnListState {
  tags: never[]
  checked: number[]
}

export const useSnList = defineStore({
  id: 'seller-sn-list',
  state: (): SnListState => ({
    tags: [],
    checked: [],
  }),
  getters: {},
  actions: {
    async getSnListData(page: number, pageSize: number, filter: Record<string, any>) {
      return getSnList({
        ...filter,
        page,
        limit: pageSize,
      }).then((res: any) => {
        this.checked = [];
        return { list: res?.data || [], total: res?.total || 0 };
      });
    },
    async upSn(ids: number[]) {
      return updateSNIsOnSale(ids.join(','), 1);
    },
    async downSn(ids: number[]) {
      return updateSNIsOnSale(ids.join(','), 0);
    },
    async editSn(data: API.GoodsSnEditData) {
      return editGoodsSn(data);
    },
    async editShuixibiao(id: number, shuixiImageIds: number[], material?: string, fabric?: string) {
      return editGoodsSnShuixibiao(id, shuixiImageIds, material, fabric);
    },
  },
});
